import styled from "styled-components";
import variaveis from "../../styles/variaveis.scss";

export const LiStyle = styled.li`
  border-bottom: 1px solid #ddd;
  display: inline-block;
  list-style: none;
  margin-bottom: -1px;
  padding: 0.5rem 0.75rem;
  width: 25%;
  cursor: pointer;
  border-radius: 5px 5px 0 0;

  :hover {
    border-top: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-left: 1px solid #ddd;
  }

  background-color: ${props =>
    props.className === "tab-list-item tab-list-active"
      ? variaveis.white
      : null};
  border: ${props =>
    props.className === "tab-list-item tab-list-active"
      ? "solid #ddd"
      : null};
  border-width: ${props =>
    props.className === "tab-list-item tab-list-active"
      ? "1px 1px 0px 1px"
      : null};
`;
